import React from 'react';
import { IconType } from 'react-icons';
import * as hi from 'react-icons/hi2';
import * as fa from 'react-icons/fa';
import styled from 'styled-components';

import { IconColor } from '../config/colorSchemes';

export type IconSize = 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';

const colorMap: Record<IconColor, string> = {
  scheme1: 'var(--scheme1-text)',
  scheme2: 'var(--scheme2-text)',
  scheme3: 'var(--scheme3-text)',
  scheme4: 'var(--scheme4-text)',
  scheme5: 'var(--scheme5-text)',
  scheme6: 'var(--scheme6-text)',
  whatsapp: 'var(--color-whatsapp)',
  linkedin: 'var(--color-linkedin)',
  github: 'var(--color-github)',
};

const sizeMap: Record<IconSize, string> = {
  xxsmall: 'calc(var(--button-icon-size) * 0.6)',
  xsmall: 'calc(var(--button-icon-size) * 0.75)',
  small: 'calc(var(--button-icon-size) * 0.9)',
  medium: 'var(--button-icon-size)',
  large: 'calc(var(--button-icon-size) * 1.2)',
  xlarge: 'calc(var(--button-icon-size) * 1.5)',
  xxlarge: 'calc(var(--button-icon-size) * 1.8)',
};

const SpanStyled = styled.span<{ $colour?: IconColor; $size?: IconSize }>`
  align-items: center;
  display: flex;
  color: ${({ $colour = 'scheme1' }) => colorMap[$colour]};
  font-size: ${({ $size = 'medium' }) => sizeMap[$size]};
  justify-content: center;
  line-height: 1; /* Ensure proper vertical alignment */
  width: ${({ $size = 'medium' }) => sizeMap[$size]};
  height: ${({ $size = 'medium' }) => sizeMap[$size]};
  &:hover {
    transform: var(--hover-scale);
    transition: var(--transition-all-ease);
  }
`;

interface IconProps {
  name: string;
  alt: string;
  size?: IconSize;
  colour?: IconColor;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, alt, size, colour, className }) => {
  const iconMap: { [key: string]: IconType } = { ...hi, ...fa };

  const IconComponent = iconMap[name];
  if (!IconComponent) {
    console.error('🚀 ~ Icon.tsx ~ Icon not found:', name);
    return null;
  }

  return (
    <SpanStyled $size={size} $colour={colour}>
      <IconComponent className={className} aria-label={alt} />
    </SpanStyled>
  );
};

export default Icon;
